import React, { useState, useEffect } from 'react';
import { NeuroMessage } from "@ignitesales/neuro-application";
import classnames from "classnames";
import { ActionService } from '@ignitesales/neuro-application/src/neuro-guide/services/ActionService.mjs';
import { useModal } from './ModalProvider';

const ActionButton = ({ className, action, position, contextData = {} }) => {
    const componentClass = "action-button";
    const classes = classnames('button', "btn", "btn-outline-secondary", componentClass, className);
    const [trigger, setTrigger] = useState(null);
    const messageId = `${trigger?._id}.button`;
    const { openModal } = useModal();

    useEffect(() => {
        ActionService.extractButtonTriggerByPosition(action, position).then(setTrigger);
    }, [action, position]);

    // Close on the global closeModal event dispatched by in-layout widget actions.
    // Buttons rendered inside LayoutRenderer can't reach this component's onClose
    // directly, so they signal via window 'ignite:closeModal' (see clickActionUtils).
    useEffect(() => {
        const handleCloseModal = () => {
            setIsModalOpen(false);
            setIsPanelOpen(false);
        };
        window.addEventListener('ignite:closeModal', handleCloseModal);
        return () => window.removeEventListener('ignite:closeModal', handleCloseModal);
    }, []);

    const actionClicked = async (trigger) => {
        const { actionType } = action;

        if (actionType === 'pop' || actionType === 'slide') {
            // Centrally owned by ModalProvider; closed via the closeModal action or the X button.
            openModal(action, contextData);
        } else if (actionType === 'run') {
            // Execute immediately (existing behavior)
            await ActionService.triggerAction(action, trigger?._id, await ActionService.extractActionParams(action, contextData));
            //TODO: handle UI events and show success and error message UI
        }
    }

    if (!trigger) return null;

    return (
        <div className="action-button-wrapper">
            <button className={classes} onClick={() => actionClicked(trigger)}>
                <NeuroMessage id={messageId} tagName="span"/>
            </button>
        </div>
    );
};

export default ActionButton;
